import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { message } from 'antd'
import type { ScrapeQueueState, ScrapeQueueItem, ScrapeQueueStatus } from '../types'
import { getScrapeQueue, clearScrapeQueue } from './helpers'

const noScrapeQueueConfig = {
  queue: [],
  status: {
    waiting: 0,
    active: 0,
    completed: 0,
    failed: 0,
    delayed: 0,
    paused: 0,
  },
  isInitalized: false,
  isLoading: true,
  hasError: false,
}

interface SetResultPayload {
  queue: ScrapeQueueItem[]
  status: ScrapeQueueStatus
}

const initialState: ScrapeQueueState = { ...noScrapeQueueConfig }

export const scrapeQueueSlice = createSlice({
  name: 'ScrapeQueue',
  initialState,
  reducers: {
    fetchResult: (state) => {
      state.isLoading = true
      state.hasError = false
    },
    setResult: (state, action: PayloadAction<SetResultPayload>) => {
      state.queue = action.payload.queue
      state.status = action.payload.status
      state.isLoading = false
      state.isInitalized = true
      state.hasError = false
    },
    fetchResultFailed: (state) => {
      state.queue = []
      state.status = noScrapeQueueConfig.status
      state.isInitalized = false
      state.isLoading = false
      state.hasError = true
    },
  },
})

export const fetchScrapeQueue = () => async (dispatch) => {
  try {
    dispatch(fetchResult())
    const { queue, status } = await getScrapeQueue()
    dispatch(
      setResult({
        queue,
        status,
      }),
    )
  } catch (error) {
    message.error('Error getting scrape queue')
    dispatch(fetchResultFailed())
  }
}

export const resetScrapeQueue = () => async (dispatch) => {
  try {
    dispatch(fetchResult())
    const results = await clearScrapeQueue()

    const { queue, status } = await getScrapeQueue()
    dispatch(
      setResult({
        queue,
        status,
      }),
    )
  } catch (error) {
    message.error('Error getting scrape queue')
    dispatch(fetchResultFailed())
  }
}

// Actions
export const { fetchResult, setResult, fetchResultFailed } = scrapeQueueSlice.actions

export default scrapeQueueSlice.reducer
